import {
  Box,
  Typography,
  Grid2,
  MenuItem,
  useTheme,
  Button,
  useMediaQuery,
} from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import PhonelinkOutlinedIcon from "@mui/icons-material/PhonelinkOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ArrowForward from "@mui/icons-material/ArrowForward";

import React, { useMemo, useState } from "react";
import ContactModal from "../../components/ContactModal";

const services_data = [
  {
    title: "Optimized Performance",
    icon: <AccountTreeOutlinedIcon />,
    description: "Fast, responsive applications that keep users engaged.",
  },
  {
    title: "Seamless User Experience",
    icon: <VerifiedUserOutlinedIcon />,
    description: "Intuitive and easy-to-user interfaces",
  },
  {
    title: "Scalability & Flexibility ",
    icon: <WorkHistoryOutlinedIcon />,
    description: "Apps that grow alongside your business..",
  },
  {
    title: "Cross-Platform Compatibility",
    icon: <PhonelinkOutlinedIcon />,
    description: "Delivering solutions for web, iOS, and Android",
  },
  {
    title: "Business-Driven Development",
    icon: <ConstructionOutlinedIcon />,
    description: "Tailored to meet specific industry needs",
  },
];

const MobileView = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          What we do?
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "'inter', sans-serif",
            maxWidth: 400,
            fontSize: {
              xs: "0.8rem",
            },
          }}
          textAlign="center"
        >
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            We help businesses unlock the full potential
          </span>{" "}
          of their data through advanced analytics, visualization, and business
          intelligence solutions. Our expertise enables companies to{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            identify trends, optimize operations, and make data-driven decisions
            with confidence
          </span>
          .
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "450px",
          backgroundImage: "url(/images/servicesone/img_two.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography
          sx={{
            marginBottom: 4,
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          How It helps
        </Typography>
        <Grid2 width="100%" container spacing={2} gap={2}>
          {services_data.map((item, index) => (
            <Grid2 item size={12} key={index}>
              <MenuItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  border: `1px solid ${theme.palette.primary.gray}`,
                  borderRadius: 2,
                  p: 2,
                  maxHeight: 200,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: {
                        xs: "1rem",
                        sm: "1.25rem",
                        md: "1.5rem",
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                  {item.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: theme.palette.primary.gray,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    fontSize: {
                      xs: "0.8rem",
                      sm: "1rem",
                      md: "1.2rem",
                    },
                  }}
                >
                  {item.description}
                </Typography>
              </MenuItem>
            </Grid2>
          ))}
        </Grid2>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: "url(/images/servicesone/services_bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          p: 4,
          gap: 4,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Why Choose Us?
        </Typography>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              At InfinityHyperCloud
            </span>
            , we create{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              powerful, high-performance applications
            </span>{" "}
            that combine innovation with efficiency. Whether you're launching a{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              customer-facing platform, an enterprise tool, or an ecommerce
              solution
            </span>
            , we build{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              future-ready applications
            </span>{" "}
            designed for success.
          </Typography>
        </Box>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            Innovate with confidence—bring your vision to life with
            InfinityHyperCloud.
          </Typography>
        </Box>
        <Button
          href="https://calendar.app.google/yyQ665soutqZzj1H9"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: "none",
            border: `1px solid ${theme.palette.primary.gray}`,
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "rgba(255,255,255,0.95)",
            borderColor: "rgba(255,255,255,0.4)",
            px: 3,
            py: 1.25,
            ml: 3,
            maxWidth: 200,
            borderRadius: 1,
            "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
          }}
          type="submit"
          variant="outlined"
          endIcon={<ArrowForward />}
        >
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "14px",
            }}
          >
            Schedule a Call
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

const WebView = ({ openModal, setOpenModal }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "90%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              height: "62vh",
            }}
          >
            <Box
              sx={{
                maxWidth: 700,
                width: "100%",
                height: 450,
                backgroundImage: "url(/images/servicesone/img_two.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
            <Box
              sx={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: 4,
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    md: "3rem",
                    laptop: "3.5rem",
                    lg: "4rem",
                    xl: "4.25rem",
                  },
                }}
                variant="h2"
              >
                What we do?
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "'inter', sans-serif",
                  maxWidth: 650,
                  fontSize: {
                    md: "0.8rem",
                    laptop: "0.8rem",
                    lg: "1.225rem",
                  },
                }}
              >
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  We help businesses unlock the full potential
                </span>{" "}
                of their data through advanced analytics, visualization, and
                business intelligence solutions. Our expertise enables companies
                to{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  identify trends, optimize operations, and make data-driven
                  decisions with confidence
                </span>
                .
              </Typography>
            </Box>
          </Box>
          {/* second section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              marginBottom: 8,
              alignItems: "center",
            }}
          >
            <Typography variant="h3">How It helps</Typography>
            <Grid2 container spacing={2} sx={{ width: "100%" }}>
              {services_data.slice(0, 4).map((item, index) => (
                <Grid2
                  size={6}
                  sx={{
                    border: `1px solid ${theme.palette.primary.gray}`,
                    borderRadius: 2,
                  }}
                >
                  <MenuItem
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h4">{item.title}</Typography>
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        color: theme.palette.primary.gray,
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontWeight: 400,
                        fontSize: {
                          md: "1.2rem",
                        },
                      }}
                    >
                      {item.description}
                    </Typography>
                  </MenuItem>
                </Grid2>
              ))}
              <Grid2
                size={12}
                sx={{
                  border: `1px solid ${theme.palette.primary.gray}`,
                  borderRadius: 2,
                }}
              >
                <MenuItem
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h4">
                      Business-Driven Development
                    </Typography>
                    <ConstructionOutlinedIcon />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      color: theme.palette.primary.gray,
                      fontWeight: 400,
                      fontSize: {
                        md: "1.2rem",
                      },
                    }}
                  >
                    Tailored to meet specific industry needs
                  </Typography>
                </MenuItem>
              </Grid2>
            </Grid2>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 12,
              marginTop: 12,
            }}
          >
            <Box
              sx={{
                width: "90%",
                backgroundImage: "url(/images/servicesone/services_bg.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  gap: 4,
                  p: 4,
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    marginBottom: 4,
                    fontSize: {
                      md: "3rem",
                      laptop: "3.5rem",
                      lg: "4rem",
                      xl: "4.25rem",
                    },
                  }}
                >
                  Why Choose Us?
                </Typography>
                <Box
                  sx={{
                    padding: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "'inter', sans-serif",
                      fontSize: {
                        md: "0.8rem",
                        laptop: "0.8rem",
                        lg: "1.225rem",
                      },
                    }}
                    textAlign="center"
                  >
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      At InfinityHyperCloud
                    </span>
                    , we create{" "}
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      powerful, high-performance applications
                    </span>{" "}
                    that combine innovation with efficiency. Whether you're
                    launching a{" "}
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      customer-facing platform, an enterprise tool, or an
                      ecommerce solution
                    </span>
                    , we build{" "}
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      future-ready applications
                    </span>{" "}
                    designed for success.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "'inter', sans-serif",
                      fontSize: {
                        md: "0.8rem",
                        laptop: "0.8rem",
                        lg: "1.225rem",
                      },
                    }}
                    textAlign="center"
                  >
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      Innovate with confidence—bring your vision to life with
                      InfinityHyperCloud.
                    </span>
                  </Typography>
                </Box>
                <Button
                  type="submit"
                  variant="outlined"
                  endIcon={<ArrowForward />}
                  href="https://calendar.app.google/yyQ665soutqZzj1H9"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "rgba(255,255,255,0.95)",
                    borderColor: "rgba(255,255,255,0.4)",
                    px: 3,
                    py: 1.25,
                    maxWidth: 200,
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                  }}
                >
                  Schedule a call
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <ContactModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

const AppDevelopment = () => {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);

  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {isMdScreen && (
        <WebView openModal={openModal} setOpenModal={setOpenModal} />
      )}
      {!isMdScreen && <MobileView />}
    </>
  );
};

export default AppDevelopment;
